import React from 'react';
import { Button } from 'reactstrap';
import { PropertiesList } from '../../models/propertyModel';
import useUpdatePropertyOperationView from '../../hooks/useUpdatePropertyOperationView';

type Props = {
  property: PropertiesList;
  editableProperties: PropertiesList[];
  setDetailProperty: (p: PropertiesList) => void;
  setDetailModalOpen: (open: boolean) => void;
  currentUserCountryCode: string;
  DETAIL_CELL_STYLE: React.CSSProperties;
  EDIT_BUTTON_STYLE: React.CSSProperties;
  currency?: string;
};

const cleanNumber = (val: any) =>
  typeof val === 'string'
    ? val.replace(/[^0-9.]/g, '')
    : val ?? '';

const PropertyPriceDetail: React.FC<Props> = ({
  property,
  editableProperties,
  setDetailProperty,
  setDetailModalOpen,
  currentUserCountryCode,
  DETAIL_CELL_STYLE,
  EDIT_BUTTON_STYLE,
  currency = '',
}) => {

  // Si currency es USD, muestra el símbolo $
  const currencyLabel = currency === 'USD' ? '$' : '';

  return (
    <div className="detalle-agrupado-cell" style={DETAIL_CELL_STYLE}>
      <div className="detalle-edit-btn" style={{
        position: 'absolute',
        top: 10,
        right: 18,
        zIndex: 2,
        opacity: 0,
        transition: 'opacity 0.2s',
        pointerEvents: 'none',
      }}>
        <Button
          size="sm"
          color="primary"
          outline
          style={EDIT_BUTTON_STYLE}
          title="Editar detalle"
          onClick={() => {
            const current = editableProperties.find(p => p.id === property.id);
            setDetailProperty({
              ...property,
              sale_price: cleanNumber(current?.sale_price),
              sale_min_price: cleanNumber(current?.sale_min_price),
            });
            setDetailModalOpen(true);
          }}
        >
          <i className="fas fa-edit" />
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          minHeight: 40,
          justifyContent: 'center',
        }}
      >
        {/* Renta */}
        <div>
          <span style={{ color: '#17a2b8', fontWeight: 500 }}>
            Solicitado: {currencyLabel}{property.price || 0}
          </span>
          <span style={{ color: '#17a2b8', fontWeight: 400, marginLeft: 8, fontSize: 13 }}>
            Mínimo: {currencyLabel}{property.offer_min_price || 0}
          </span>
        </div>
        {/* Venta */}
        <div>
          <span style={{ color: '#6f42c1', fontWeight: 500 }}>
            Solicitado: {currencyLabel}{property.sale_price || 0}
          </span>
          <span style={{ color: '#6f42c1', fontWeight: 400, marginLeft: 8, fontSize: 13 }}>
            Mínimo: {currencyLabel}{property.sale_min_price || 0}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PropertyPriceDetail;